function normForMatch(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

const GEMINI_SUGGESTIONS_FALLBACK =
  'No pudimos obtener sugerencias automáticas claras a partir del documento. Revisá el borrador o probá con otro archivo.'

export function sanitizePublicAssistantText(text: string | null | undefined): string {
  const raw = String(text ?? '')
  const trimmed = raw.trim()
  if (!trimmed) return raw
  const n = normForMatch(trimmed)
  if (n.includes('gemini') && n.includes('sugerencias') && n.includes('validas') && n.includes('analisis')) {
    return GEMINI_SUGGESTIONS_FALLBACK
  }
  return raw
}
